import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'liquid-payout-portal';

  constructor(){
    console.log('Version 1.3.12');
  }
}
